import React from "react";
import { usePassionsData, POPULAR_PASSION_IDS } from "~/hooks/usePassionsData";
import { usePassionsStore } from "~/store";
import { Hero } from "./Hero";
import { getAnalyticsClickTrackingAttributes } from "~/utils/adobeDataLayerUtils";
import passionSlides from "~/data/destinationData.json";
import AvatarImage from "../../assets/passions/Avatar.png";

export const HeroPassion = ({ selectedPassions: propSelectedPassions }) => {
  const { getSelectedPassions, loading, profile } = usePassionsData();

  const storeSelectedPassions = usePassionsStore(
    (state) => state.selectedPassions,
  );
  const cdpPassions = propSelectedPassions || getSelectedPassions();

  const selectedPassions =
    storeSelectedPassions && storeSelectedPassions.length > 0
      ? storeSelectedPassions
      : cdpPassions;

  // Determine correct headline based on profile presence
  let headline = "Become a Bonvoy member to start earning points";

  if (profile && profile.nextLevel) {
    const nights = profile.nightsToNextLevel || 0;
    const nightText = nights === 1 ? "Night" : "Nights";
    const nextLevelName =
      profile.nextLevel.charAt(0).toUpperCase() +
      profile.nextLevel.slice(1).toLowerCase();

    headline = `${nights} More ${nightText} Unlock ${nextLevelName} Elite Status`;
  }
  const handleBookStay = (passion, slide) => {
    console.log("Book your next stay clicked for passion:", passion, slide);
    // Scroll to Discover Your Next Destination section
    const element = document.getElementById("hotels-by-passion-carousel");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Shuffle array utility function
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Get all available passions from the slide data
  const getAllAvailablePassions = () => {
    return Object.keys(passionSlides);
  };

  // Generate slides based on user's passions
  const generatePassionSlides = () => {
    let slidesToShow = [];

    if (selectedPassions.length === 0) {
      // No passions selected - show most popular passions
      // Rule: if NO values exist, then show an image for each of the “most popular” Passions (Golf, Ski, Beach)
      // Rule: If user does not exist in CDP, then act like NO values exist for Passions
      POPULAR_PASSION_IDS.forEach((passion) => {
        if (passionSlides[passion]?.slides?.length > 0) {
          const randomSlide =
            passionSlides[passion].slides[
              Math.floor(Math.random() * passionSlides[passion].slides.length)
            ];
          slidesToShow.push({ passion, slide: randomSlide });
        }
      });
    } else if (selectedPassions.length === 1) {
      // Only 1 passion - show all slides for that passion (up to 3)
      // Rule: if only one value exists, then show 3 images for that Passion
      const passion = selectedPassions[0];
      if (passionSlides[passion]?.slides) {
        const slides = passionSlides[passion].slides.slice(0, 3);
        slides.forEach((slide) => {
          slidesToShow.push({ passion, slide });
        });
      }
    } else {
      // More than 1 passion
      // Rule: if more than one value exists, show one image/tile for each Passion
      selectedPassions.forEach((passion) => {
        if (passionSlides[passion]?.slides?.length > 0) {
          const randomSlide =
            passionSlides[passion].slides[
              Math.floor(Math.random() * passionSlides[passion].slides.length)
            ];
          slidesToShow.push({ passion, slide: randomSlide });
        }
      });
    }

    return slidesToShow;
  };

  // Convert passion slides to Hero component format
  const convertToHeroSlides = (passionSlideData) => {
    return passionSlideData.map(({ passion, slide }) => {
      // Capitalize passion name for display
      const passionTitle = passion.charAt(0).toUpperCase() + passion.slice(1);

      return {
        title: slide.title,
        subtitle: `Discover ${passionTitle} Experiences`,
        description: slide.description,
        backgroundImage: slide.image,
        ctaText: "Book your next stay",
        ctaVariant: "primary",
        onCtaClick: () => handleBookStay(passion, slide),
        ctaAttributes: {
          ...getAnalyticsClickTrackingAttributes(
            "Hero Passion",
            "click",
            "Book your next stay",
          ),
          className: "custom_click_track",
        },
        avatarImage: AvatarImage,
        passionType: passion,
      };
    });
  };

  // Show loading state
  if (loading && selectedPassions.length === 0) {
    return (
      <div
        style={{
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
        }}
      >
        <p>Loading your personalized experiences...</p>
      </div>
    );
  }

  // Generate the slides
  const passionSlideData = generatePassionSlides();
  const heroSlides = convertToHeroSlides(passionSlideData);

  console.log("HeroPassion slides:", heroSlides);

  // Fallback if no slides could be generated
  if (heroSlides.length === 0) {
    const defaultSlide = {
      title: "Discover Your Next Adventure",
      subtitle: "Personalized Travel Experiences",
      description:
        "Complete your passion profile to see curated recommendations just for you",
      backgroundImage:
        "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200&h=600&fit=crop&crop=center",
      ctaText: "Explore Destinations",
      ctaVariant: "primary",
      onCtaClick: () => console.log("Explore destinations clicked"),
      avatarImage: AvatarImage,
    };
    heroSlides.push(defaultSlide);
  }

  return (
    <Hero
      slides={heroSlides}
      headline={headline}
      autoPlayInterval={6000} // 6 seconds to give more time to read
      pauseOnHover={true}
      overlay={true}
      textPosition="center"
    />
  );
};
